const APP_ENVIRONMENT = {
  PRODUCTION: 'production',
  STAGING: 'staging',
  PREVIEW: 'preview',
  DEVELOPMENT: 'development',
}

const IS_PRODUCTION = (process.env.GATSBY_ENVIRONMENT === APP_ENVIRONMENT.PRODUCTION);
const IS_STAGING = (process.env.GATSBY_ENVIRONMENT === APP_ENVIRONMENT.STAGING);
const IS_PREVIEW = (process.env.GATSBY_ENVIRONMENT === APP_ENVIRONMENT.PREVIEW);

const defaultConfig = {
  ewb: {
    galleryName: 'Every Women Biennial NFT Gallery',
    collectionEmbedIframe: 'https://opensea.io/collection/every-woman-biennial?embed=true',
    contactEmail: 'superchiefgallerynft@gmail.com',
    logoSrcName: 'ewb-logo-horizontal.png',
    themeColor: 'rgb(133, 124, 140)',
    faviconName: 'favicon-ewb.ico',
    social: {
      insta: 'https://www.instagram.com/everywomanbiennial/',
      twitter: 'https://twitter.com/whbiennial',
      facebook: 'https://m.facebook.com/everywomanbiennial/',
      instagram: 'https://www.instagram.com/everywomanbiennial/',
    }
  },
  season1: {
    galleryName: 'Superchief Gallery - Season 1',
    collectionEmbedIframe: 'https://opensea.io/collection/superchief-gallery-nifty?embed=true',
    contactEmail: 'superchiefgallerynft@gmail.com',
    logoSrcName: 'season1-logo-horizontal.png',
    themeColor: '#00c9c9',
    faviconName: 'favicon-superchief.ico',
    social: {
      insta: 'https://www.instagram.com/superchiefgallery/',
      twitter: 'https://twitter.com/superchieftv',
      facebook: 'https://www.facebook.com/SuperchiefGalleryLA/',
      instagram: 'https://www.instagram.com/superchiefgallery/',
    }
  }
};

let config;

// if (IS_PREVIEW) {
//   config = {
//     API_URL: 'https://api.preview.yourbase.io',
//   }
// } else if (IS_STAGING) {
//   config = {
//     API_URL: 'https://api.staging.yourbase.io',
//   }
// } else if (IS_PRODUCTION) {
//   config = {
//     API_URL: 'https://api.yourbase.io',
//   }
// }

// console.log('Env', process.env.GATSBY_ENVIRONMENT, config);

export default Object.assign(defaultConfig, config);
